import type { FC } from 'react';
import { createContext } from 'react';

import type { Card } from '@shared/cards-types';

export type CardRenderer = FC<{ cardId: Card['id'] }>;

// History print and export are shared features that both render search/filter criteria.
// This requires product IDs to be resolved into readable data, like card number.

// However, because there is no shared product or card abstraction, renderers must
// be passed down from Business or Retail context.

// The planned solution is to create a unified search state renderer for account
// history, global search, print and export. This will include the option to define
// Business-only or Retail-only fields in proper context.

// Until the unified renderer is implemented, we circumvent package restrictions
// by wrapping features in context that provides rendering components for products.

interface ProductsRenderingContext {
    maskedCardNumber?: CardRenderer;
}

export const ProductsRenderingContext = createContext<ProductsRenderingContext>({});
